module.exports = __webpack_public_path__ + "static/media/dashboard.416f61d9.png";